/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Can from "../../components/Can";
import moment from "moment";
import Pagination from "../../components/Panigation";
import { toast } from "react-toastify";
import DeleteConfirmModal from "../../Modals/DeleteConfirmModal";
import { useDeleteNotificationMutation, useGetNotificationsQuery } from "../../service/features/api";


const NotificationsList = ({ searchTerm, type, page, setPage }: any) => {
  const navigate = useNavigate();

  const { data, isLoading } = useGetNotificationsQuery({
    search: searchTerm || undefined,
    type: type === "default" ? undefined : type,
    page,
    limit: 10,
  });

  const rows = data?.data?.data || [];
  const paginator = data?.data?.paginator;

  const [deleteNotification, { isLoading: isDeleting }] = useDeleteNotificationMutation();
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [selectedId, setSelectedId] = React.useState("");

  const handleConfirmDelete = async () => {
    try {
      const res = await deleteNotification(selectedId).unwrap();
      toast.success(res.message || "Notification deleted successfully");
      setOpenDeleteModal(false);
    } catch (err: any) {
      toast.error(err?.data?.message || "Something went wrong");
    }
  };

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Image</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Created Date</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {!isLoading && rows.length > 0 ? (
              rows.map((row: any) => (
                <TableRow hover key={row.id}>
                  <TableCell>
                    <img
                      src={row.image || "/static/images/placeholder.png"}
                      alt="Notification"
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "4px",
                        objectFit: "cover",
                      }}
                    />
                  </TableCell>
                  <TableCell>{row.title}</TableCell>
                  <TableCell>{row.type}</TableCell>

                  <TableCell>
                    {row.createdAt
                      ? moment(row.createdAt).format("DD-MMM-YYYY")
                      : "-"}
                  </TableCell>

                  <TableCell>
                    <Box className="table_actions v2">
                      <Tooltip title="View" arrow>
                        <IconButton
                          onClick={() =>
                            navigate(`/manage-notifications/detail/${row.id}`)
                          }
                        >
                          <img src="/static/images/eye_icon.svg" alt="View" />
                        </IconButton>
                      </Tooltip>

                      <Can
                        module="Notification Management"
                        action="isDelete"
                        isDisabledMode={true}
                      >
                        <Tooltip title="Delete" arrow>
                          <IconButton
                            onClick={() => {
                              setSelectedId(row.id);
                              setOpenDeleteModal(true);
                            }}
                          >
                            <img
                              src="/static/images/trash2_icon.svg"
                              alt="Delete"
                            />
                          </IconButton>
                        </Tooltip>
                      </Can>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  {isLoading ? "Loading..." : "No notifications found"}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {paginator && paginator.pageCount > 0 && (
        <Pagination
          module={rows}
          page={page}
          onPageChange={setPage}
          totalPages={paginator.pageCount}
          totalCount={paginator.itemCount}
          setPage={setPage}
        />
      )}

      <DeleteConfirmModal
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        isLoading={isDeleting}
      />
    </>
  );
};

export default NotificationsList;